// API response status constants
export enum ApiFetchStatus {
  SUCCESS = 'success',
  ERROR= 'error',
  LOADING= 'loading',
  NOT_STARTED= 'not_started',
};

// Error Types
export enum AppDetailsFetchErrorType {
  NETWORK_ERROR = 'networkError',
  PARSING_ERROR = 'parsingError',
}